import DataStore from "../../../../core/stores/dataStore.js";

module.exports = function (componentId, legends) {
  var updateCallback = null;
  var HISTORY_SIZE = 40;
  this.id = componentId;

  this.loadHistoricData = function (historicData) {
    var data = [];
    for(var key in historicData) {
      data = historicData[key];
    }
    if (updateCallback != null) {
      updateCallback(data);
    }
  };

  this.prepareData = function (historicData) {
    var datasetData = {};

    // return single dataset data
    for (var key in legends[0].mappings) {
      var datasetId = legends[0].mappings[key].datasetId;
      datasetData = DataStore.get(datasetId);
    }

    return datasetData;
  };

  this.update = function () {
    if (updateCallback != null) {
      var datasetData = this.prepareData();
      updateCallback(datasetData);
    }
  };


  this.addUpdateListener = function (callback) {
    updateCallback = callback;
  };

  this.resize = function () {

  };

  this.onDataFieldsModified = function (allDataFields) {

  };

  // TODO: history size is how many data points does the chart display prior to start
  // updating itself on real-time updates. This value is hard-coded for now.
  this.getHistorySize = function () {
    return HISTORY_SIZE;
  };

  this.getLegends = function () {
    return legends;
  };

  this.destroy = function () {
  }
};


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/table/controller.js